// extracted by mini-css-extract-plugin
export default {"Grid":"Grid_Grid__Xmcg1"};